<div class="search-dropdown mat-open-menu-container"
     [ngClass]="controller.model.isSearching ? 'mat-active mat-clickable': 'mat-leave'">
  <div *ngIf="controller.model.isSearching">
    <ng-container [ngComponentOutlet]="controller.view.search"
                  [ngComponentOutletInjector]="controller.view.searchInjector"></ng-container>
  </div>
</div>
